// eslint-disable-next-line import/prefer-default-export
export const MODULES = {
	sections: import.meta.glob('/resources/react/v4/components/sections/*/*.jsx'),
	variants: import.meta.glob('/resources/react/v4/components/sections/*/Variants/*/*.jsx'),
}
